import { authApi, authApiTreeviaGateway } from '../clients/AxiosClients'

const loginUser = async (data) => {
	data.clientId = 'smartforest-front'
	return await authApi.post('/api/v1/Auth/login', data)
}

const loginUserTreeviaGateway = async (data) => {
	data.clientId = 'smartforest-front'
	return await authApiTreeviaGateway.post('/api/v1/Auth/login', data)
}

export { loginUser, loginUserTreeviaGateway }
